import { Call } from '@/shared/call';

export class State {
    public nextAvailableCall: Call | null = null;
    public callbacks: Array<Call> = [];
    public activeCalls: Array<Call> = [];

}
